import React, { useState, useEffect } from 'react';
import { Breadcrumb, BreadcrumbItem, Row, Col } from 'reactstrap';
import toast, { Toaster } from 'react-hot-toast';
import { withAuthenticationRequired } from "@auth0/auth0-react";
import {
    useNavigate
} from "react-router-dom";

//Componentes
import LoadingTransparent from '../../components/modales/loadingModalTransparent';
import IconCard from '../../components/cards/iconCard';
import CustomModal from '../../components/modales/customModal';
import BodyCreateGroup from './components/BodyCreateGroup';
import BodyDeleteGroup from './components/BodyDeleteGroup';

//Redux
import { connect } from 'react-redux';
//API Calls
import { functionsHttpsCallable } from '../../utils/FirebaseStorage/firebase';

const eliminarGrupo = functionsHttpsCallable('correos_eliminarGrupo');
const crearGrupo = functionsHttpsCallable('correos_crearGrupo');

//Toast
const toastSuccess = (msg) => toast.success(msg);
const toastError = (msg) => toast.error(msg);

//Info usuario en Reducer
const mapStateToProps = state => ({
    usuarioActivo: state
})

let GestionCorreos = (props) => {
    const navigate  = useNavigate();
    const [modal, setModal] = useState(false);
    const [modalTransaction, setModalTransaction] = useState(false);
    const [activeModal, setActiveModal] = useState(1);
    const [searchEmail, setSearchEmail] = useState(undefined);
    const [userData] = useState(JSON.parse(localStorage.getItem('userData')));
    const [usersList, setUsersList] = useState([]);
    useEffect(() => {
        document.title = "Gestión de correos";
    })

    useEffect(() => {
    }, [])



    const createGroup = async (data) => {
        try {
            const request = await crearGrupo(data);
            if (request.data.status === 'GRUPO_CREADO') {
                toastSuccess('Grupo de correos creado!');
                toggleModal()
            }
            else {
                toastError('Ocurrió un error');
                toggleModal()
            }
        }
        catch (error) {
            console.log('error', error)
            toastError('Ocurrió un error');
        }

    }
    const deleteGroup = async (data) => {
        try {
            const request = await eliminarGrupo(data);
            if (request.data.status === 'GRUPO_ELIMINADO') {
                toastSuccess('Grupo de correos eliminado!');
                toggleModal()
            }
            else {
                toastError('Ocurrió un error');
                toggleModal()
            }

        }
        catch (error) {
            toastError('Ocurrió un error');
        }

    }

    const getBodyModal = () => {
        switch (activeModal) {
            case 2:
                return <BodyDeleteGroup 
                    onClick={(e) => { deleteGroup(e) }} />
            case 1:
            default:
                return <BodyCreateGroup
                    onClick={(e) => { createGroup(e) }} />
        }
    }
    const getTitleModal = () => {
        switch (activeModal) {
            case 2:
                return 'Eliminar Grupo'
            case 1:
            default:
                return 'Crear Grupo Envio Masivo Correos'
        }
    }
    const toggleModal = () => setModal(!modal);

    const renderModal = () => {
        return (
            <CustomModal
                modal={modal}
                toggle={() => toggleModal()}
                title={getTitleModal()}
                buttonTitle={'Ok'}
                nonFooter={true}
                size={'lg'} 
            >
                {getBodyModal()}
            </CustomModal>
        )
    }
    return (
        <div>
            {renderModal()}
            <Toaster />
            <LoadingTransparent isOpen={modalTransaction} />
            <Breadcrumb>
                <BreadcrumbItem className='breadcum-display-content' active>
                    Gestión de Correos
                </BreadcrumbItem>
            </Breadcrumb>
            <div className='user-management-page'>
                <Row>
                    <Col lg='4' md='6' xs="12">
                        <IconCard
                            icon={'AiOutlineUsergroupAdd'}
                            subText={'Crear Grupo Correos'}
                            onClick={() => { 
                                setActiveModal(1)
                                toggleModal()
                                }}/>
                    </Col>
                    <Col lg='4' md='6' xs="12">
                        <IconCard
                            icon={'AiOutlineUsergroupDelete'}
                            subText={'Eliminar Grupo Correos'}
                            onClick={() => { 
                                setActiveModal(2)
                                toggleModal()
                                }}/>
                    </Col>
                    <Col lg='4' md='6' xs="12">
                        <IconCard
                            icon={'AiOutlineSend'}
                            subText={'Enviar Correo Masivo'}
                            onClick={() => { 
                                navigate('/home/mail-composer');
                                }}/>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default connect(mapStateToProps)(GestionCorreos);